/* import __COLOCATED_TEMPLATE__ from './class-groups.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();